
import { defineComponent, ref, onMounted } from 'vue'
import { MqResponsive, useMq } from 'vue3-mq'

import AsFileDragAndDrop from '@web/components/AsFileDnD.vue'
import AsFileUploader from '@web/components/AsFileUploader.vue'
import AsCamera from '@web/components/AsCamera.vue'
import AsDropDown from '@web/components/AsDropDown.vue'
import useFormHomework from '@web/composition/useFormHomework'
import { useRouter, useRoute } from 'vue-router'

export default defineComponent({
  name: 'AsFormHomework',
  components: {
    MqResponsive,
    AsFileDragAndDrop,
    AsFileUploader,
    AsCamera,
    AsDropDown
  },
  props: {
    expertsChatId: {
      type: Number,
      required: true
    },
    homework: {
      type: Object as () => {
        status: HomeworkStatus;
        homework: Homework;
        stageHomework: StageHomework | undefined;
        dayHomework: DayHomework | undefined;
      },
      required: true
    }
  },
  setup (props) {
    const router = useRouter()
    const route = useRoute()
    const asFormHomeworkEl = ref<HTMLElement | null>()

    const mq = useMq()

    let status: 'open' | 'close' = 'close'
    function setDropDownMenuHeightForMobile () {
      if (window.innerWidth < 1244) {
        const menuTarget: HTMLElement | null = document.querySelector('.asDropDown_menu')
        if (menuTarget) {
          menuTarget.style.maxHeight = 'calc(100vh - 378px)'
        }
      }
    }
    function setHeightForMobile () {
      if (!asFormHomeworkEl.value) {
        return
      }

      if (status === 'close') {
        asFormHomeworkEl.value.style.height = '76px'
        asFormHomeworkEl.value.style.minHeight = ''
        asFormHomeworkEl.value.style.overflow = 'hidden'
      } else {
        const hPreviews = (document.querySelector('.asFormHomework_previews') as HTMLElement).scrollHeight
        const hContent = (document.querySelector('.asFormHomework_content') as HTMLElement).scrollHeight

        asFormHomeworkEl.value.style.height = ''
        asFormHomeworkEl.value.style.minHeight = `${95 + hPreviews + hContent}px`
        asFormHomeworkEl.value.style.overflow = 'auto'
      }
    }
    function toggleVisibility () {
      status = status === 'open' ? 'close' : 'open'
      setHeightForMobile()
      setDropDownMenuHeightForMobile()
    }

    onMounted(() => {
      setDropDownMenuHeightForMobile()
    })

    const elMessage = ref<Element | null>(null)
    const elFileUpload = ref<typeof AsFileDragAndDrop | null>(null)
    return {
      ...useFormHomework({
        homework: props.homework,
        chatId: props.expertsChatId,
        elMessage,
        router,
        route,
        reset () {
          if (elFileUpload.value) {
            elFileUpload.value.$el.dispatchEvent(new CustomEvent('reset'))
          }
        }
      }),
      setHeightForMobile,
      toggleVisibility,
      status,
      mq,
      asFormHomeworkEl
    }
  }
})
